module.exports = __webpack_public_path__ + "static/capita-land-32dd52bf2f0ff277cc9997984cbf74b1.svg";